import React from 'react';
import { Route, Switch } from 'react-router-dom';

import NetworkForm from 'routes/app/components/Broadcast/NetworkForm';

class Facebook extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={this.props.match.path} render={() => <NetworkForm type="facebook"/>}/>
      </Switch>
    )
  }
}

module.exports = Facebook;



// WEBPACK FOOTER //
// ./routes/app/routes/broadcast/facebook/index.js